import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REPORTSB_API_URL } from "config";

// Reports-b sub-page feature-flag overrides (industryBenchmarking, darkWebMonitoring, ...),
// persisted per-tenancy in the ReportLayouts DynamoDB table (SK = FEATURES) and resolved up the
// parent chain by the reporting-api /dashboard/features endpoints. Replaces the featureFlags.js
// localStorage prototype layer. Product-copy labels + code defaults stay in featureFlags.js;
// only the on/off overrides live here.
const baseQuery = fetchBaseQuery({
    baseUrl: REPORTSB_API_URL,
    prepareHeaders: (headers) => {
        const user = localStorage.getItem('user');
        if (user) {
            const token = JSON.parse(user).token;
            if (token) headers.set('authorization', `Bearer ${token}`);
        }
        return headers;
    },
    credentials: "omit"
});

export const reportsBFeaturesApi = createApi({
    reducerPath: "reportsBFeaturesApi",
    baseQuery,
    tagTypes: ['ReportsBFeatures'],
    endpoints: (builder) => ({
        getReportsBFeatures: builder.query({
            query: (tenancyId) => ({ url: `dashboard/features/${tenancyId}`, method: 'GET' }),
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response.status,
            providesTags: ['ReportsBFeatures'],
        }),
        saveReportsBFeatures: builder.mutation({
            query: ({ tenancyId, flags }) => ({
                url: `dashboard/features/${tenancyId}`,
                method: 'PUT',
                body: { flags },
            }),
            // NB: deliberately does NOT invalidate getReportsBFeatures. The toggle is already
            // reflected locally (setFeature) before this fires; re-fetching immediately would do
            // an eventually-consistent DynamoDB read that can return the pre-toggle value and
            // clobber the just-applied override via hydrateOverrides. Boot hydration + the strongly
            // consistent GET keep other sessions/machines in sync.
        }),
    }),
});

export const { useGetReportsBFeaturesQuery, useSaveReportsBFeaturesMutation } = reportsBFeaturesApi;
